import React from "react";

type CommonModalProps = {
  show: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

const CommonModal: React.FC<CommonModalProps> = ({
  show,
  onClose,
  children
}) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <button className="close-btn" onClick={onClose}>
         <i className="bx bx-x"></i>
        </button>

        <div className="modal-body">
          {children}
        </div>

      </div>
    </div>
  );
};

export default CommonModal;